import { useState } from 'react';
import { connect } from 'react-redux';
import {
  changeCitationRequestDisplay,
  changeCitationRequestPopupWindow,
} from '../actions/citationRequestAction';

import CitationRequestsCalendar from '../components/citation-request/CitationRequestsCalendar';
import CitationRequestServicePopup from '../components/citation-request/CitationRequestServicePopup';
import CitationTable from '../components/citation-request/CitationTable';

import tableStyles from '../styles/citation-request/CitationTable.module.scss';

const CitationRequestContainer = props => {
  const storageKey = 'citationRequestSelectedMonth';
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [statuses, setStatuses] = useState({
    pending: true,
    approved: true,
    'in-progress': true,
    completed: true,
    delivered: true,
    withdrawn: true,
  });

  return (
    <div className='main-container'>
      <div
        style={{
          display: 'flex',
          flexDirection: window.innerWidth > 896 ? 'row' : 'column',
        }}>
        <div className='col flex-grow-1 p-0'>
          <CitationRequestsCalendar
            storageKey={storageKey}
            selectedDate={selectedDate}
            setSelectedDate={setSelectedDate}
            statuses={statuses}
            setStatuses={setStatuses}
          />
          <CitationRequestServicePopup
            selectedDay={selectedDate}
            shownStatuses={statuses}
          />
        </div>
        <div
          className={`col flex-grow-0 p-0 ${tableStyles['citation-list-container']}`}>
          <CitationTable
            changeCitationRequestDisplay={props.changeCitationRequestDisplay}
            changeCitationRequestPopupWindow={
              props.changeCitationRequestPopupWindow
            }
          />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = () => ({});

const mapDispatchToProps = {
  changeCitationRequestDisplay,
  changeCitationRequestPopupWindow,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CitationRequestContainer);
